<template>
  <v-container>
    <kim-background/>
    <v-row>
      <v-col cols="12">
        <h1>{{$i18n.t('OverviewPage.title')}}</h1>
        <h3>{{$i18n.t('OverviewPage.welcome')}} {{currentObserver.firstName}} {{currentObserver.lastName}},</h3>
        <p>{{$i18n.t('OverviewPage.pleaseChoose')}}</p>
      </v-col>
    </v-row>

    <v-row align="center" class="mt-5">

    <v-expansion-panels accordion="accordion">
      <v-expansion-panel v-for="participant in observerTimeTable" :key="participant.id">
        <v-expansion-panel-header class="justify-self-start">
          <div>

            <v-list-item-avatar size="36" class="mr-2">
              <img v-if="participantImage(participant.id, participantImages)" :src="participantImage(participant.id, participantImages)">
              <v-icon v-else class="grey lighten-1 white--text">mdi-account</v-icon>
            </v-list-item-avatar>

            <v-icon :color="businessLogic.getParticipantRatingStatus(participant, assessments, runInfo.competencyExerciseMatrix)">{{ businessLogic.getParticipantRatingIcon(participant, assessments, runInfo.competencyExerciseMatrix) }}</v-icon>
            <span class="ml-5">{{participant.firstName}} {{participant.lastName}}</span>
            <v-icon class="ml-5" v-if='participant.documentUrl && participant.documentName'>mdi-text-box-search-outline</v-icon>
<!--            <span v-if="runInfo.runInformation.runState === 5" class="primary&#45;&#45;text pl-3" @click.stop="downloadFeedback(participant.id)">(<v-icon>mdi-file-pdf</v-icon> Feedback)</span>-->
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list>
            <v-list-item v-if='participant.documentUrl && participant.documentName' @click='businessLogic.setParticipant(participant.id)'>
              <v-list-item-content>{{ $t('OverviewPage.toParticipantDocument') }}</v-list-item-content>
            </v-list-item>
            <v-list-item v-for="(schedule,i) in participant.exercises" :key="`ex_${participant.id}_${schedule.exerciseId}_${i}`" @click="businessLogic.setParticipantAndExercise(schedule.exerciseId,participant.id, schedule.interviewId)">

              <v-list-item-avatar>
                <v-icon color="grey lighten-1">mdi-information</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>{{schedule.exercise.name}}</v-list-item-title>
                <v-list-item-subtitle v-text="businessLogic.getRoomAndTime(schedule)"></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn icon>
                  <v-icon :color="businessLogic.getExerciseRatingStatus(schedule, assessments, participant.id, runInfo.competencyExerciseMatrix)">{{ businessLogic.getExerciseRatingIcon(schedule, assessments, participant.id, runInfo.competencyExerciseMatrix)}}</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import BusinessLogicOverview from '@/libs/businessLogicOverview';
import BusinessLogicAssessments from '@/libs/businessLogicAssessments';
import dayjs from 'dayjs'
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc'
import KimBackground from './KimBackground.vue';

dayjs.extend(tz);
dayjs.extend(utc);


export default {
  name: 'Overview',
  components: {
    KimBackground,
  },
  data: () => ({
    businessLogic: new BusinessLogicOverview(null),
    businessLogicAssessments: new BusinessLogicAssessments(null),
  }),
  computed: {
    currentObserver() {
      return this.$store.getters.currentObserver;
    },
    assessments() {
      return this.$store.getters.assessments;
    },
    participantImages() {
      return this.$store.getters.participantImages;
    },
    ...mapState(['runInfo', 'observerTimeTable']),
  },
  methods: {
    // testHub() {
    //   this.$hub.setup()()
    // },
    setParticipantAndExercise(exerciseId, participantId) {
      this.businessLogic.setParticipantAndExercise(exerciseId, participantId);
    },
    participantImage(participantId, images) {
      const imageList = images();
      if (imageList[participantId] === 404) return null;
      if (imageList[participantId]) {
        return imageList[participantId];
      }
      this.businessLogic.getParticipantImage(participantId);

      // update this component after 3 seconds to display participant photos
      const self = this;
      setTimeout(() => {
        self.$forceUpdate();
      }, 3000);

      return null;
    },
    downloadFeedback(participantId) {
      console.log('DOWNLOAD FEEDBACK', participantId);
      let fileName = dayjs(this.runInfo?.runInformation?.runDate).format('YYYY-MM-DD');
      if (this.runInfo?.runInformation?.projectId) fileName += `-${this.runInfo?.runInformation?.projectId}`;
      const participant = this.runInfo?.participants?.find((c) => c.id === participantId);
      if (participant) fileName += `-${participant.firstName}-${participant.lastName}`
      fileName += '-feedback.pdf'
      this.$apiRequest.getFile(`/candidates/${participantId}/feedback`, fileName);
    }
  },
  mounted() {
    this.businessLogic = new BusinessLogicOverview(this);
  },
};
</script>
